import DOMPurify from 'dompurify';

export function purifyHTML(html) {
  return DOMPurify.sanitize(html);
}
